<template>
  <div >
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true,y:true}"
      rowKey="id"
      :columns="columns"
      :pagination="false"
      :dataSource="dataSource"
      class="j-table-force-nowrap">
      <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
        <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >
          <div v-if="column.dataIndex=='carList'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
            <span  class="tb-span-click" v-if="record.carList && record.carList.length" v-for="(item,idx) in record.carList" @click.stop="viewCar(record)">{{idx?(","+item.licensePlateNumber):item.licensePlateNumber}}</span>
            <span v-else>-</span>
          </div>
          <div v-else-if="column.dataIndex=='driverName'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
            <span   :style="{color:record.driverLabel?'#ff0000':''}">{{text}}</span>
          </div>
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="column.dataIndex=='platformNum'?record.platformName:text" v-else>
            <img :title="text" v-if="(column.dataIndex=='createByName' && record.createByAvatar) || (column.dataIndex=='updateByName' && record.updateByAvatar)" :src="getImgView((column.dataIndex=='createByName'?record.createByAvatar:record.updateByAvatar))" height="25px" alt="" style="width:25px;font-size: 12px;font-style: italic;border-radius:50%"/>
            <span  class="tb-span-click" v-else-if="column.dataIndex=='workOrderNum'" @click.stop="workList(record)">{{text || '-'}}</span>
            <span  class="tb-span-click" v-else-if="column.dataIndex=='platformNum'" @click.stop="platList(record)">{{text || '-'}}</span>
            <span  v-else >{{text || '-'}}</span>
          </div>
        </slot>
      </template>
    </a-table>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'DriverInfoTable',
    mixins:[JeecgListMixin, mixinDevice],
    components: {},
    props:{
      model:{
        type:Object,
        default: {}
      }
    },
    data() {
      return {
        menuTab:"driver3.0",
        dataSource:[],
        disableMixinCreated:true,
        columns: [

          {
            title:'客户姓名',
            align:"center",
            dataIndex: 'driverName',
            position:'left',
            width:120,
            scopedSlots: { customRender: 'textSlot' }
          },
          {
            title:'所属城市',
            align:"center",
            position:'left',
            dataIndex: 'areaName',
            width:150,
            scopedSlots: { customRender: 'areaName_dictTextSlot' }
          },
          {
            title:'手机号码',
            align:"center",
            width:240,
            dataIndex: 'phone',
            scopedSlots: { customRender: 'phoneSlot' }
          },
          {
            title:'身份证号码',
            align:"center",
            width:240,
            dataIndex: 'idNumber',
            scopedSlots: { customRender: 'idNumberSlot' }
          },
          {
            title:'更新人',
            align:"center",
            dataIndex: 'updateByName',
            position:"right",
            width:140,
            scopedSlots: { customRender: 'updateByNameSlot' }
          },
          {
            title:'更新日期',
            align:"center",
            position:"right",
            width:240,
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTimeSlot' }
          }
        ],
        defaultColumns: [

          {
            title:'客户姓名',
            align:"center",
            dataIndex: 'driverName',
            width:120,
            scopedSlots: { customRender: 'textSlot' }
          },
          {
            title: 'ID',
            dataIndex: 'id',
            align:"center",
            width:140,
            scopedSlots: { customRender: 'IDSlot' }
          }
          ,
          {
            title:'手机号码',
            align:"center",
            width:240,
            dataIndex: 'phone',
            scopedSlots: { customRender: 'phoneSlot' }
          },
          {
            title:'身份证号码',
            align:"center",
            width:240,
            dataIndex: 'idNumber',
            scopedSlots: { customRender: 'idNumberSlot' }
          },
          {
            title:'出生年月',
            align:"center",
            dataIndex: 'birthDate',
            width:180,
            scopedSlots: { customRender: 'birthDateSlot' }
          },
          {
            title:'户口地址',
            align:"center",
            dataIndex: 'accountAddress',
            width:240,
            scopedSlots: { customRender: 'accountAddressSlot' }
          },
          {
            title:'民族',
            align:"center",
            dataIndex: 'nation',
            width:150,
            scopedSlots: { customRender: 'nationSlot' }
          },
          {
            title:'发证机关',
            align:"center",
            dataIndex: 'licenceIssuing',
            width:200,
            scopedSlots: { customRender: 'licenceIssuingSlot' }
          },
          {
            title:'所属城市',
            align:"center",
            dataIndex: 'areaName',
            width:150,
            scopedSlots: { customRender: 'areaName_dictTextSlot' }
          },
          {
            title:'标签',
            align:"center",
            dataIndex: 'driverLabel_dictText',
            width:200,
            scopedSlots: { customRender: 'driverLabelSlot' }
          },
          {
            title:'身份证有效期起',
            align:"center",
            width:240,
            dataIndex: 'cardBeginTime',
            scopedSlots: { customRender: 'cardBeginTimeSlot' }
          },
          {
            title:'身份证有效期止',
            align:"center",
            dataIndex: 'cardEndTime',
            width:240,
            scopedSlots: { customRender: 'cardEndTimeSlot' }
          },
          {
            title:'创建人',
            align:"center",
            dataIndex: 'createByName',
            width:140,
            scopedSlots: { customRender: 'createSlot' }
          },
          {
            title:'创建日期',
            align:"center",
            dataIndex: 'createTime',
            width:240,
            scopedSlots: { customRender: 'createTimeSlot' }
          },
          {
            title:'更新人',
            align:"center",
            dataIndex: 'updateByName',
            width:140,
            scopedSlots: { customRender: 'updateByNameSlot' }
          },
          {
            title:'更新日期',
            align:"center",
            width:240,
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTimeSlot' }
          },
          {
            title:'驾驶证号码',
            align:"center",
            width:180,
            dataIndex: 'licenseNo',
            scopedSlots: { customRender: 'licenseNoSlot' }
          },
          {
            title:'准驾车型',
            align:"center",
            dataIndex: 'quasiDrivingVehicle_dictText',
            width:140,
            scopedSlots: { customRender: 'quasiDrivingVehicle_dictTextSlot' }
          },
          {
            title:'首次领证日期',
            align:"center",
            width:180,
            dataIndex: 'firstReviceDate',
            scopedSlots: { customRender: 'firstReviceDateSlot' }
          }
          ,
          {
            title:'驾驶证有效期起',
            align:"center",
            width:180,
            dataIndex: 'beginTime',
            scopedSlots: { customRender: 'beginTimeSlot' }
          },
          {
            title:'驾驶证有效期止',
            align:"center",
            width:180,
            dataIndex: 'endTime',
            scopedSlots: { customRender: 'endTimeSlot' }
          }
          ,
          {
            title:'人证核验',
            align:"center",
            width:180,
            dataIndex: 'licenseFlag_dictText',
            scopedSlots: { customRender: 'licenseFlag_dictTextSlot' }
          },
          {
            title:'人证编号',
            align:"center",
            width:180,
            dataIndex: 'ddplLicenseNo',
            scopedSlots: { customRender: 'ddplLicenseNoSlot' }
          },
          {
            title:'人证姓名',
            align:"center",
            width:180,
            dataIndex: 'realname',
            scopedSlots: { customRender: 'realnameSlot' }
          }
        ]
      }
    },methods:{
     async init(){
        await  this.loadColumn();
        await this.formatModel();
      },formatModel(){
       let md = {
         ...this.model
       }
        md.driverLabel_dictText = md.driverLabelStr;
       if(md.quasiDrivingVehicle){
         md.quasiDrivingVehicle_dictText =  filterDictTextByCache("quasi_driving_vehicle",md.quasiDrivingVehicle);
       }
        if(md.licenseFlag){
          md.licenseFlag_dictText =  filterDictTextByCache("persona_license_flag",md.licenseFlag);
        }else{
          md.licenseFlag_dictText =  "无人证";
        }
        this.dataSource = [md];
        console.log("this.dataSource",this.dataSource);
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/tableList.less';
@import '~@assets/less/dm/newTable.less';
</style>